import { ServiceOffer } from "../common/const";
import { apiRequest } from "./common";

const checkBookingSession = async (type, studentId,subService) => {
    const response = await apiRequest('get', `/mentor/book-session/${type}/${studentId}${subService ? `?studentSubjectId=${subService}` : ''}`);
    return response.data;
};

const confirmBooking = async (data) => {
    const response = await apiRequest('post', `/session/confirm`, data);
    return response.data;
};

const bookSessionDirect = async (data) => {
    const response = await apiRequest('post', `/mentor-session/book-direct`, data);
    return response.data;
};

const getEventByInvite = async (url) => {
    const response = await apiRequest('get', `/session/by-invitee?uri=${url}`);
    return response.data;
};

const getIntakeEventByInvite = async (url) => {
    const response = await apiRequest('get', `/intake/by-invitee-uri?uri=${url}`);
    return response.data;
};

const getUpcomingSession = async (service, studentId, subService) => {
    const response = await apiRequest('get', `/session/student/upcoming-sessions?service=${service}&studentId=${studentId}${subService ? service === ServiceOffer.mentor ? `&projectId=${subService}` : `&studentSubjectId=${subService}` : ''}`);
    return response.data;
};

const getPastSession = async (pageNo, pageSize, service, studentId, subService) => {
    const response = await apiRequest('get', `/session/student/past-sessions?page=${pageNo}&limit=${pageSize}&service=${service}&studentId=${studentId}${subService ? service === ServiceOffer.mentor ? `&projectId=${subService}` : `&studentSubjectId=${subService}` : ''}`);
    return response.data
};

const createNotes = async (data) => {
    const response = await apiRequest('post', `/session-note`, data);
    return response.data
};

const updateSesson = async (sessionId, data) => {
    const response = await apiRequest('put', `/session/${sessionId}`, data);
    return response.data
};

const sumbitReview = async (data) => {
    const response = await apiRequest('post', `/session-review/submit`, data);
    return response.data
};

export {
    checkBookingSession,
    confirmBooking,
    bookSessionDirect,
    getEventByInvite,
    getIntakeEventByInvite,
    getUpcomingSession,
    getPastSession,
    createNotes,
    updateSesson,
    sumbitReview
}